import { ProductListByCategoryPath } from './product-list-by-category-path'

export { ProductListByCategoryPath } from './product-list-by-category-path'

export default ProductListByCategoryPath
